import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref } from 'vue';

enum CountdownState {
	DayCountdown = 'DAY_COUNTDOWN',
	HourCountdown = 'HOUR_COUNTDOWN',
	Started = 'STARTED'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ToylandBanner',
  setup(__props) {

const MINUTE_SECONDS = 1000 * 60;
const HOUR_SECONDS = MINUTE_SECONDS * 60;
const DAY_SECONDS = HOUR_SECONDS * 24;

const eventBegins: Date = new Date(1728734400000); // 7:00 AM October 12, 2024

const now = ref(new Date());

const state = computed((): CountdownState => {
	if (now.value > eventBegins) {
		return CountdownState.Started;
	}

	const diff = eventBegins.getTime() - now.value.getTime();
	if (diff > 48 * HOUR_SECONDS) {
		return CountdownState.DayCountdown;
	}

	return CountdownState.HourCountdown;
});

/**
 * The countdown display object.
 */
const countdown = computed(() => {
	const diff = eventBegins.getTime() - now.value.getTime();

	const fullDays = Math.floor(diff / DAY_SECONDS);
	const hours = Math.floor((diff % DAY_SECONDS) / HOUR_SECONDS) + (fullDays * 24);
	const minutes = Math.floor((diff % HOUR_SECONDS) / MINUTE_SECONDS);
	const seconds = Math.floor((diff % MINUTE_SECONDS) / 1000);

	const calendarDays = Math.round((midnight(eventBegins).getTime() - midnight(now.value).getTime()) / DAY_SECONDS);

	return {
		days: calendarDays,
		hours: hours.toString().padStart(2, '0'),
		minutes: minutes.toString().padStart(2, '0'),
		seconds: seconds.toString().padStart(2, '0')
	};
});

function midnight(date: Date): Date {
	const d = new Date(date);
	d.setHours(0);
	d.setMinutes(0);
	d.setSeconds(0);
	d.setMilliseconds(0);
	return d;
}

/**
 * Used for testing purposes. Could remove or comment after development done
 */
function getTestDateFromUrl(): Date | null {
	const urlParams = new URLSearchParams(window.location.search);
	const testDate = urlParams.get('testDate');
	if (!testDate) {
		return null;
	}

	if (!/^\d{14}$/.test(testDate)) {
		console.error('Invalid date string format. Expected YYYYMMDDHHMMSS');
	}

	const year = parseInt(testDate.slice(0, 4));
	const month = parseInt(testDate.slice(4, 6)) - 1; // Months are 0-indexed
	const day = parseInt(testDate.slice(6, 8));
	const hour = parseInt(testDate.slice(8, 10));
	const minute = parseInt(testDate.slice(10, 12));
	const second = parseInt(testDate.slice(12, 14));

	return new Date(year, month, day, hour, minute, second);
};

let lastIntervalTime = new Date();
let timer: number | null = null;
onMounted(() => {
	const testDate = getTestDateFromUrl();
	if (testDate) {
		now.value = testDate;
	}

	if (state.value !== CountdownState.Started) {
		lastIntervalTime = new Date();
  		timer = window.setInterval(() => {
			const elapsed = Date.now() - lastIntervalTime.getTime();
			now.value = new Date(now.value.getTime() + elapsed);
			lastIntervalTime = new Date();
		}, 1000);
	}
});

onUnmounted(() => {
	if (timer != null) {
		clearInterval(timer);
	}
});

return { __sfc: true,CountdownState, MINUTE_SECONDS, HOUR_SECONDS, DAY_SECONDS, eventBegins, now, state, countdown, midnight, getTestDateFromUrl, lastIntervalTime, timer }
}

})